import React from 'react'
import { connect } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

import SearchDoormanForm from '../components/form/SearchDoormanForm'
import { getDoormen } from '../store/doormen/actions'
import { roles } from '../utils/constants'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    fontFamily: 'Montserrat, Source Sans Pro'
  }
}))

const SettingsDoormanPage = ({
  currentSchool,
  getDoormen,
  doormen,
  userOccupations
}) => {
  const classes = useStyles()
  const isAdmin =
    userOccupations?.includes(roles.SCHOOL_ADMIN) ||
    userOccupations?.includes(roles.VERSAR_ADMIN)
  const isVersarAdmin = userOccupations?.includes(roles.VERSAR_ADMIN)

  React.useEffect(
    () => {
      currentSchool &&
        getDoormen({ params: { 'q[school_id_eq]': currentSchool.school_id } })
    },
    [currentSchool]
  )

  return (
    <div className={classes.root}>
      <SearchDoormanForm
        getDoormen={getDoormen}
        doormen={doormen}
        school={currentSchool}
        isAdmin={isAdmin}
        isVersarAdmin={isVersarAdmin}
      />
    </div>
  )
}

const mapStateToProps = ({ auth, school, doormen }) => {
  return {
    userOccupations: auth.currentOccupation,
    currentSchool: school.currentSchool,
    doormen: doormen
  }
}

const mapDispatchToProps = dispatch => ({
  getDoormen: data => dispatch(getDoormen(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(SettingsDoormanPage)
